import React from "react";
import {ProfileFragment} from "./profile/ProfileFragment";
import {PathComponent} from "../index";
import {BaseShowcaseFragment} from "./BaseShowcaseFragment";

export class ViewProfileFragment extends BaseShowcaseFragment {

  static nestedPaths(): PathComponent[] {
    return ProfileFragment.nestedPaths();
  }

  protected renderPageContent(): React.ReactElement | null {
    return <ProfileFragment
      userProfile={this.state.userProfile}
      path={this.props.path}/>
  }
}